/* eslint-disable import/prefer-default-export */
export function getPasswordUpdateFailureOptions(error) {
  const errorCode = error.response?.data.error?.code;
  const errorMessage = error.response?.data.error?.message ?? error.message;

  switch (errorCode) {
    case 'ERR_USER_UPT_PASSWORD':
      return {
        title: 'Senha atual incorreta',
        message: 'A senha digitada não bate com a cadastrada no sistema atualmente.',
      };
    default:
      return { errorList: [errorMessage] };
  }
}
